import {atom, onSet} from "nanostores"

export const $fullScreen = atom(false)